import { AuthApi } from "./apis";
import { persistor, store } from "./store";

// Scopes whose stored session app.tsx validates with /me before mounting the routes.
export const BOOT_VALIDATED_SCOPES = ["AUTHORIZED", "RESTRICTED_SESSION", "FORGOT_PIN", "RESET_PIN"];

let pending: Promise<any> | null = null;

/**
 * Fire the boot /me as soon as redux-persist has rehydrated the token.
 * DehubThemeProvider renders nothing until /theme/resolve returns, so when
 * App started /me itself the two requests ran one after the other and the
 * dashboard (the LCP) waited for both. /me needs only the store, not the theme.
 */
export function prefetchBootMe() {
  let started = false;
  const run = () => {
    if (started || !persistor.getState().bootstrapped) return;
    started = true;
    unsubscribe();
    if (new URLSearchParams(window.location.search).has("logout")) return;
    const { accessToken, sessionScope } = store.getState().auth ?? {};
    if (accessToken && BOOT_VALIDATED_SCOPES.includes(sessionScope || "")) {
      pending = AuthApi.me();
      // App attaches the real handlers; this only keeps an early 401 from being reported as unhandled.
      pending.catch(() => {});
      // The page this session lands on is a lazy chunk that app.tsx only asks for
      // after /me returns; fetch it now so the two overlap (same chunk, webpack
      // reuses the request).
      prefetchLandingPage(sessionScope);
    }
  };
  const unsubscribe = persistor.subscribe(run);
  run();
}

function prefetchLandingPage(sessionScope?: string | null) {
  const atRoot = window.location.pathname.replace(/\/+$/, "") === ((window as any).__BASE_PATH__ || "").replace(/\/+$/, "");
  const load =
    sessionScope === "AUTHORIZED" && atRoot
      ? () => import("./pages/main/index")
      : sessionScope === "RESTRICTED_SESSION"
        ? () => import("./pages/businesses")
        : null;
  // A failed prefetch is retried by lazyPage when the route renders.
  load?.().catch(() => {});
}

/** The prefetched boot /me, or a new request when none was started. Repeated calls (StrictMode) share one request. */
export function bootMe(): Promise<any> {
  if (!pending) pending = AuthApi.me();
  return pending;
}
